import React, { useEffect, useRef, useState } from "react";
import style from "css/telehealth.module.css";
import { Link } from "react-router-dom";
import Questions from "components/app/questions";
import { useDispatch } from "react-redux";
import { openPopup } from "redux/slices/drawerPopupSlice";
import NeatPopup from "components/device/neat/neatPopup";

function Symposium() {
  // const [body, setBody] = useState(1);
  //dispatch
  const dispatch = useDispatch();
  const [info, setInfo] = useState(1);

  const infoBodyList = [
    {
      header: "고품질의 화상 및 음향 제공",
      img: "img/smartspace/consolution6.png",
      body2: (
        <font>
          Neat 디바이스는 고해상도 비디오와 탁월한 음향 품질을 제공하여,
          <br />
          발표자와 청중 간의 명확하고 원활한 소통을 가능하게 합니다.
          <br /> 이는 세미나의 몰입도를 높이고, 정보 전달의 정확성을 보장합니다.
        </font>
      ),
    },
    {
      header: "고품질의 화상 및 음향 제공2",
      img: "img/smartspace/consolution6.png",
      body2: (
        <font>
          Neat 디바이스는 고해상도 비디오와 탁월한 음향 품질을 제공하여,
          <br />
          발표자와 청중 간의 명확하고 원활한 소통을 가능하게 합니다.
          <br /> 이는 세미나의 몰입도를 높이고, 정보 전달의 정확성을 보장합니다.
        </font>
      ),
    },
    {
      header: "고품질의 화상 및 음향 제공3",
      img: "img/smartspace/consolution6.png",
      body2: (
        <font>
          Neat 디바이스는 고해상도 비디오와 탁월한 음향 품질을 제공하여,
          <br />
          발표자와 청중 간의 명확하고 원활한 소통을 가능하게 합니다.
          <br /> 이는 세미나의 몰입도를 높이고, 정보 전달의 정확성을 보장합니다.
        </font>
      ),
    },
    {
      header: "고품질의 화상 및 음향 제공4",
      img: "img/smartspace/consolution6.png",
      body2: (
        <font>
          Neat 디바이스는 고해상도 비디오와 탁월한 음향 품질을 제공하여,
          <br />
          발표자와 청중 간의 명확하고 원활한 소통을 가능하게 합니다.
          <br /> 이는 세미나의 몰입도를 높이고, 정보 전달의 정확성을 보장합니다.
        </font>
      ),
    },
    {
      header: "고품질의 화상 및 음향 제공5",
      img: "img/smartspace/consolution6.png",
      body2: (
        <font>
          Neat 디바이스는 고해상도 비디오와 탁월한 음향 품질을 제공하여,
          <br />
          발표자와 청중 간의 명확하고 원활한 소통을 가능하게 합니다.
          <br /> 이는 세미나의 몰입도를 높이고, 정보 전달의 정확성을 보장합니다.
        </font>
      ),
    },
    {
      header: "고품질의 화상 및 음향 제공6",
      img: "img/smartspace/consolution6.png",
      body2: (
        <font>
          Neat 디바이스는 고해상도 비디오와 탁월한 음향 품질을 제공하여,
          <br />
          발표자와 청중 간의 명확하고 원활한 소통을 가능하게 합니다.
          <br /> 이는 세미나의 몰입도를 높이고, 정보 전달의 정확성을 보장합니다.
        </font>
      ),
    },
  ];

  const [infoBody, setInfoBody] = useState(infoBodyList[0]);
  useEffect(() => {
    setInfoBody(infoBodyList[info - 1]);
  }, [info]);

  const scrollContainerRef = useRef(null);

  const handleMouseDown = (e) => {
    const container = scrollContainerRef.current;
    container.isDown = true;
    container.startX = e.pageX - container.offsetLeft;
    container.scrollLeft = container.scrollLeft;
  };

  const handleMouseLeave = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseUp = () => {
    const container = scrollContainerRef.current;
    container.isDown = false;
  };

  const handleMouseMove = (e) => {
    const container = scrollContainerRef.current;
    if (!container.isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - container.startX) * 0.5; // 스크롤 속도 조절
    container.scrollLeft = container.scrollLeft - walk;
  };

  const ComposeHeader = (
    <div className={style.commonComposeTitle}>
      원격진료 시스템 <font>구성 환경</font>
    </div>
  );

  const Compose = [
    {
      id: 1,
      img: "img/smartspace/composeImg1.png",
      title: "스마트 워크 플랫폼 all Place",
      txt: "all Place는 회의실/자율좌석 예약 및 관리 플랫폼입니다.\n 사용자가 PC나 모바일을 통해 쉽게 예약할 수 있게 해주며, \n예얀된 내용을 회의실 디스플레이 장비와 실시간으로 동기화됩니다.",
      onClick: () => showDrawer("allplace"),
    },
    {
      id: 2,
      img: "img/smartspace/composeImg1.png",
      title: "neat. frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
    {
      id: 3,
      img: "img/smartspace/composeImg1.png",
      title: "neat. frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
    {
      id: 4,
      img: "img/smartspace/composeImg1.png",
      title: "neat. frame",
      txt: "Neat Frame은 간결하면서도 강력한 화상 디바이스로, 가상 \n 리셉셔니스트 역할에 최적화된 장비입니다. 고해상도 디스플레이와 \n 초고화질 카메라를 탑재하여, 방문자와 직원 모두에게 선명하고\n 깨끗한 화면으로 소통할 수 있습니다.",
      onClick: () => showDrawer("frame"),
    },
  ];
  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };

  return (
    <>
      <NeatPopup />
      <div className={style.wrapper}>
        <div className={style.healthTitle}>
          <p>Medical Symposium & Conference</p>
          <p>의료 세미나 / 학술대회</p>
          <p>
            의료세미나 및 학술대회를 비대면으로 개최/참여할 수 있습니다. <br />
            시간과 장소의 제약 없이 최신 의료 지식과 연구 결과를 공유하고 논의할
            수 있습니다.
          </p>
        </div>
        <div className={style.sympImg}>
          <img
            alt=""
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/roundingImg1.png"
            }
          />
        </div>
        <div className={style.sympTitle2}>
          <p>
            <font>고해상도 화상회의 기능을 통해 </font>
            발표와 토론이 원활하게 이루어지며, 실시간 질문과 답변, 자료 공유 등
            다양한 인터랙티브 기능을 지원합니다.
          </p>
          <p>
            또한, 학술대회 참가자들은 전 세계 어디서든 참여할 수 있어,{" "}
            <font>글로벌 의료 커뮤니티의 형상과 협력을 촉진</font>합니다.
          </p>
        </div>
        <div
          className={style.healthBody2}
          style={{
            backgroundImage:
              "url('" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              "img/smartspace/teleBackgroundImg.png')",
          }}
        >
          <div className={style.consolutionInfo}>
            <div className={style.consolutionInfoHeader}>
              <font>리브테크놀로지의 Telehealth</font>
              <font> 의료세미나 / 학술대회 시스템</font>
            </div>
            <div className={style.consolutionInfoTypeList}>
              <div
                onClick={() => {
                  setInfo(1);
                }}
                className={info === 1 ? style.infoOn : style.infoOff}
              >
                {" "}
                고품질의 화상 <br /> 및 음향 제공
              </div>
              <div
                className={info === 2 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(2);
                }}
              >
                편리한 사용과
                <br /> 높은 접근성
              </div>
              <div
                className={info === 3 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(3);
                }}
              >
                글로벌 접근성
                <br /> 및 유연성
              </div>
              <div
                className={info === 4 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(4);
                }}
              >
                전용 사이트 구축으로
                <br /> 맞춤형 환경
              </div>
              <div
                className={info === 5 ? style.infoOn : style.infoOff}
                onClick={() => {
                  setInfo(5);
                }}
              >
                보안
                <br /> 및 안정성
              </div>
            </div>
            <div className={style.consolutionInfoBody}>
              <div>
                <img
                  alt=""
                  src={`${process.env.REACT_APP_CLIENT_URL}` + infoBody.img}
                />
              </div>
              <div>
                <font>{infoBody.header}</font>
                {infoBody.body2}
              </div>
            </div>
          </div>
        </div>
        <div className={style.commonCompose}>
          <div className={style.commonCompseBody}>
            {ComposeHeader}
            <div
              className={style.commonComposeCardWrap}
              ref={scrollContainerRef}
              onMouseDown={handleMouseDown}
              onMouseLeave={handleMouseLeave}
              onMouseUp={handleMouseUp}
              onMouseMove={handleMouseMove}
            >
              {Compose.map((info) => (
                <div className={style.commonComposeCard}>
                  <div className={style.commonComposeCardImg}>
                    <p>
                      <font>{info.id}</font> / {Compose.length}
                    </p>
                    <img
                      alt=""
                      src={`${process.env.REACT_APP_CLIENT_URL}` + info.img}
                    />
                  </div>
                  <div className={style.commonComposeCardTxt}>
                    <p>{info.title}</p>
                    <p>{info.txt}</p>
                  </div>
                  <div className={style.commonComposeCardMore}>
                    <Link
                      to={`${process.env.REACT_APP_CLIENT_URL + info.link}`}
                    >
                      <div>
                        <font>More</font>{" "}
                        <img
                          alt=""
                          src={
                            `${process.env.REACT_APP_CLIENT_URL}` +
                            "img/smartspace/arrowRight.png"
                          }
                        />
                      </div>
                    </Link>
                  </div>
                </div>
              ))}
            </div>
            <div className={style.commonComposeFooter}>
              <div
                style={{
                  backgroundImage:
                    "url('" +
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/composefooterImg.png')",
                }}
              >
                <p>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/bang.png"
                    }
                  />
                </p>
                <p>
                  <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다. 상담을
                  통해 정확히 진단해 보세요.
                </p>
              </div>
            </div>
            <div className={style.commonComposeFooter}>
              <div
                style={{
                  backgroundImage:
                    "url('" +
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/smartspace/composefooterImg.png')",
                }}
              >
                <p>
                  <img
                    alt=""
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/smartspace/bang.png"
                    }
                  />
                </p>
                <p>
                  <font>기업 환경에 맞춰</font> 선택하여 구축 가능합니다. 상담을
                  통해 정확히 진단해 보세요.
                </p>
              </div>
            </div>
          </div>
          <Questions />
        </div>
      </div>
    </>
  );
}

export default Symposium;
